import amount from '@core/components/payments/payments-amount.vue';
<template>
  <label :class="color">
    {{ label }}
  </label>
</template>

<script>
  export default {
    props: {
      amount: {
        type: String,
        default: ''
      }
    },

    computed: {
      label: function () {
        const amount_number = parseFloat(this.amount);
        const round_amount = amount_number.toFixed(2);

        if (amount_number > 0) {
          return '+' + round_amount;
        }
        return round_amount;
      },
      color: function () {
        const amount_number = parseFloat(this.amount);

        if (amount_number > 0) {
          return 'text-green';
        } else if (amount_number < 0) {
          return 'text-red';
        }
        return undefined;
      }
    }
  };
</script>